<ng-container *adaptLoadingUntilFirstEmit="let team of team$">
    <adapt-toolbar-inactive [entity]="team"
                            type="group"></adapt-toolbar-inactive>

    <div adaptToolbarContent>
        <a [routerLink]="teamDashboardLink$ | async"
           adaptButton="dashboardLink"
           adaptTooltip="Go to group dashboard"></a>
    </div>

    <adapt-configuration-page-base [team]="team"
                                   [configGroups]="configGroups"
                                   configTitle="{{ team?.name }} group configuration"
                                   (selectedItemChange)="selectedItem = $event">
        @if (selectedItem?.area === ConfigArea.TeamProfile) {
            <adapt-configure-team-details-new [team]="team"
                                              [configItem]="selectedItem"> </adapt-configure-team-details-new>
        }
        @if (selectedItem?.area === ConfigArea.People) {
            <adapt-configure-team-membership [team]="team"
                                             [configItem]="selectedItem"> </adapt-configure-team-membership>
        }
        @if (selectedItem?.area === ConfigArea.ExternalLink) {
            <adapt-configure-external-dashboard [team]="team"
                                                [configItem]="selectedItem"> </adapt-configure-external-dashboard>
        }
        @if (selectedItem?.area === ConfigArea.ObjectivesAndKeyResults) {
            <adapt-configure-objectives [team]="team"
                                        [configItem]="selectedItem"> </adapt-configure-objectives>
        }
        @if (selectedItem?.area === ConfigArea.ValuesConstitution) {
            <adapt-configure-values-constitution [team]="team"
                                                 [configItem]="selectedItem"> </adapt-configure-values-constitution>
        }
        @if (selectedItem?.area === ConfigArea.Kanban) {
            <adapt-configure-team-kanban [team]="team"
                                         [configItem]="selectedItem"> </adapt-configure-team-kanban>
        }
        @if (selectedItem?.area === ConfigArea.Meetings) {
            <adapt-configure-team-meetings [team]="team"
                                           [configItem]="selectedItem"></adapt-configure-team-meetings>
        }
        @if (selectedItem?.area === ConfigArea.TeamAssessment) {
            <adapt-configure-team-assessment [team]="team"
                                             [configItem]="selectedItem"> </adapt-configure-team-assessment>
        }
        @if (selectedItem?.area === ConfigArea.AccessPermissions) {
            <adapt-configure-team-access-permissions [team]="team"
                                                     [configItem]="selectedItem"> </adapt-configure-team-access-permissions>
        }
    </adapt-configuration-page-base>
</ng-container>
